/**
 * Compliance routes — Wave 6.2 cart-resolution-code workflow surfaces.
 *
 * Mounted under `/compliance/*` from App.tsx. The existing /rcc module
 * remains the dashboard hub; this set is a small, dedicated subtree for the
 * Adverse-Action queue and per-cart compliance review entry point.
 *
 *   /compliance                            → redirect to /compliance/adverse-action-queue
 *   /compliance/adverse-action-queue       → AdverseActionQueue
 *   /compliance/adverse-review/:cartId     → AdverseReviewLanding
 */

import { Navigate, Route, Routes } from 'react-router';
import { SplatRedirect } from '@/components/common/SplatRedirect';
import { AdverseActionQueue } from './AdverseActionQueue';
import { AdverseReviewLanding } from './AdverseReviewLanding';

export default function Compliance(): JSX.Element {
  return (
    <Routes>
      <Route index element={<Navigate to="adverse-action-queue" replace />} />
      <Route path="adverse-action-queue" element={<AdverseActionQueue />} />
      <Route path="adverse-review/:cartId" element={<AdverseReviewLanding />} />
      <Route path="*" element={<SplatRedirect to="adverse-action-queue" />} />
    </Routes>
  );
}
